module.exports = __webpack_public_path__ + "static/media/conveyor1.668b4e50.png";